export default __webpack_public_path__ + "static/media/2023-03-02T06_09_48.757Z_2_3.99893720.jpeg";